<template>
  <div class="ma-1 ma-sm-4">
    <!-- {{ rgpOptions }} -->
    <div v-if="1 == -1"></div>
    <div v-else-if="route == 'RgpMaterials'">
      <rgp-materials
        :isAdmin="isAdmin"
        :rgpOptions="rgpOptions"
        :materialList="materialList"
        @getMaterialList="getMaterialList()"
      ></rgp-materials>
    </div>
    <div v-else-if="route == 'RgpCompanies'">
      <rgp-companies
        :isAdmin="isAdmin"
        :rgpOptions="rgpOptions"
      ></rgp-companies>
    </div>

    <div v-else-if="route == 'RgpDetails'">
      <rgp-details
        :isAdmin="isAdmin"
        :rgpOptions="rgpOptions"
        :materialList="materialList"
        @getMaterialList="getMaterialList()"
      ></rgp-details>
    </div>
    <div v-else>
      <rgp-list :isAdmin="isAdmin" :rgpOptions="rgpOptions"></rgp-list>
    </div>
  </div>
</template>

<script>
import ApiServices from "@/services/ApiServices";
// import RgpCompanies from "@/components/gpStuff/RgpCompanies.vue";
import UserMixin from "@/assets/js/UserMixin";
// import Name from "../dir/file";

export default {
  name: "RgpHome",
  components: {
    RgpCompanies: () => import("@/components/gpStuff/RgpCompanies.vue"),
    RgpMaterials: () => import("@/components/gpStuff/RgpMaterials.vue"),
    RgpList: () => import("@/components/gpStuff/RgpList.vue"),
    RgpDetails: () => import("@/components/gpStuff/RgpDetails.vue"),
  },
  mixins: [UserMixin],

  props: {},
  data: function () {
    return {
      rgpOptions: null,
      route: null,
      materialList: null, // store materials here then trickle down to child components
    };
  },
  methods: {
    getRgpOptions() {
      ApiServices.genericApiCall("/rgps/options")
        .then((response) => {
          if (response.data) this.rgpOptions = response.data;
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {});
    },
    getMaterialList() {
      if (this.materialList) return this.materialList;
      ApiServices.genericApiCall("/rgps/materials")
        .then((response) => {
          if (response.data) {
            this.materialList = response.data;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
  computed: {},
  mounted() {
    this.getRgpOptions();
    this.route = this.$route.name;
  },
};
</script>

<style scoped></style>
